var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoresLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#F1F4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3496 22C27.1389 30.7887 22.7369 49.4397 31.5256 63.6504C40.3143 77.8611 58.9653 82.2631 73.176 73.4744L41.3496 22Z",
    fill: "#2B5B4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.093 26.448C32.3364 33.7182 28.6936 49.1483 35.9715 60.9049C43.2417 72.6615 58.6718 76.3042 70.4283 69.0263L44.093 26.448Z",
    fill: "#D7513E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0807 36.1186C43.1988 36.6631 42.2708 36.7551 42.0024 36.318C41.734 35.8885 42.2325 35.0986 43.1067 34.5541C43.9887 34.0096 44.9166 33.9176 45.185 34.3547C45.4611 34.7842 44.9626 35.5818 44.0807 36.1186Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3034 46.05C38.4214 46.5945 37.4935 46.6865 37.2251 46.2494C36.9566 45.8199 37.4551 45.03 38.3294 44.4855C39.2113 43.941 40.1393 43.849 40.4077 44.2861C40.6761 44.7156 40.1776 45.5055 39.3034 46.05Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8932 48.1513C47.0113 48.6958 46.0833 48.7878 45.8149 48.3507C45.5465 47.9212 46.045 47.1313 46.9192 46.5868C47.8012 46.0423 48.7291 45.9503 48.9975 46.3874C49.266 46.8169 48.7675 47.6068 47.8932 48.1513Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3737 57.9216C40.4917 58.4661 39.5638 58.5581 39.2954 58.121C39.027 57.6915 39.5254 56.9016 40.3997 56.3571C41.2816 55.8126 42.2096 55.7206 42.478 56.1577C42.7464 56.5872 42.2479 57.3771 41.3737 57.9216Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6276 59.1333C50.7456 59.6778 49.8177 59.7699 49.5493 59.3327C49.2809 58.9033 49.7793 58.1133 50.6536 57.5688C51.5355 57.0243 52.4635 56.9323 52.7319 57.3695C53.0003 57.7989 52.5095 58.5888 51.6276 59.1333Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8424 66.5109C60.9605 67.0554 60.0325 67.1474 59.7641 66.7103C59.4957 66.2808 59.9942 65.4909 60.8685 64.9464C61.7504 64.4019 62.6783 64.3099 62.9468 64.747C63.2152 65.1765 62.7244 65.9664 61.8424 66.5109Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0299 67.5155C50.148 68.06 49.22 68.1521 48.9516 67.7149C48.6832 67.2855 49.1817 66.4956 50.056 65.9511C50.9379 65.4066 51.8658 65.3145 52.1343 65.7517C52.4103 66.1811 51.9119 66.971 51.0299 67.5155Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresLogo1);
export default __webpack_public_path__ + "static/media/stores-logo-1.a678efec475791d556503fb769172a2a.svg";
export { ForwardRef as ReactComponent };